import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util from 'service/util';

import Form from 'component/Form';
import PopMessage from 'component/pop-msg/PopMessage';
import ModalScreen from 'component/ModalScreen';

class RemoveServiceModal extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      error: '',
    };

    this.submitModal = this.submitModal.bind(this);
  }

  submitModal(e)
  {
    e.preventDefault();
    e.stopPropagation();

    let { start_dtm, owner_id, cd_license } = this.props.service;
    start_dtm = Util.ShortDate(start_dtm);
    API.deleteServiceRecord({ start_dtm, owner_id, cd_license }).then(resp =>
    {
      if (resp.success) {
        let index = this.props.vehicle.services.indexOf(this.props.service);
        this.props.vehicle.services.splice(index, 1);
        PopMessage.show('已成功移除記錄。', '成功', 'success');
        this.props.closeModal();
      } else {
        PopMessage.show(resp.msg, '失敗', 'danger');
      }
    });

    return false;
  }

  render()
  {
    const v = this.props.vehicle;
    const s = this.props.service;
    return (
      <ModalScreen className="sem sem-remove" show={true}
        title={`移除服務記錄 - ${v.cd_license}`}
        onClose={this.props.closeModal}>
        <Form className="sem-form" onSubmit={this.submitModal}>
          <p className="message red">
            此動作將無法復原，你確定要移除以下記錄嗎？
          </p>
          <table className="data-table full-width">
            <thead>
              <tr>
                <th>公司</th>
                <th>開戶日期</th>
                <th>開始日期</th>
                <th>結束日期</th>
                <th>計劃</th>
                <th>附加項目</th>
                <th>月費</th>
                <th>附加費</th>
                <th>服務日</th>
                <th>打蠟</th>
                <th>工人</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="srv-company">{ Util.getCompanyName(s.company) }</td>
                <td className="srv-reg-dtm">{ Util.ShortDate(s.reg_dtm) }</td>
                <td className="srv-start-dtm">{ Util.ShortDate(s.start_dtm) }</td>
                <td className="srv-end-dtm">{ Util.ShortDate(s.end_dtm) }</td>
                <td className="srv-plan">
                  <span className={`p ${s.srv_plan}`}>{ s.srv_plan }{ s.vh_type }</span>
                </td>
                <td className="srv-rotation">${ s.rotation }</td>
                <td className="srv-fee">${ s.fee || 0 }</td>
                <td className="srv-exfee">${ s.extra_fee || 0 }</td>
                <td className="srv-weekday">
                  <span>{ Util.WeekdayName(s.weekday1) }</span>
                  <span>{ Util.WeekdayName(s.weekday2) }</span>
                  <span>{ Util.WeekdayName(s.weekday3) }</span>
                </td>
                <td className="srv-waxing">
                  { !s.waxing?'':<FontAwesomeIcon icon={faCheck} /> }
                </td>
                <td className="srv-worker" tilte={ `ID:${s.worker}` }>
                  { s.worker_name }
                </td>
              </tr>
            </tbody>
          </table>

          <div className="error-msg">
            { this.state.error }
          </div>
          <div className="action-panel">
            <button className="btn grey" type="button"
                    onClick={e=>this.props.closeModal()}>關閉</button>
            <button id="btn-submit" className="btn red" >移除</button>
          </div>
        </Form>
      </ModalScreen>
    );
  }

}


export default RemoveServiceModal;